export default __webpack_public_path__ + "static/media/img_11.f6a008ab.jpg";